import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../shared/user.service';
// Begning Confirmation
import { ConfirmationService } from '@jaspero/ng2-confirmations';
import { ResolveEmit } from '../../../app/resolve-emit';
import { ConfirmSettings } from '../../../app/confirm-settings';
// end of Confirmation
import { Menu } from '../../shared/menu.model';
import { EmployeePortalService }  from '../../shared/HR_ADMIN/EmployeePortal/EmployeePortalService.service';
import { EmployeeCompoffModel }  from '../../shared/HR_ADMIN/EmployeePortal/EmployeeCompoffModel.model';
import { ModalOptions,BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-compoff-approval',
  templateUrl: './compoff-approval.component.html',
  styleUrls: ['./compoff-approval.component.css']
})

export class CompoffApprovalComponent implements OnInit 
{
  CompOffApplication: EmployeeCompoffModel[]=[];
  directduty: any;
  ModelListApplication: EmployeeCompoffModel;
  userClaims: any;
  SubMenues : Menu[]=[];
  Mod : any;
  Approver: any;
  Result : string;
  SuccessStatus:boolean=false;
  SuccessMessage: string ="";
  public tableWidget: any;
  RefId : any;
  // Begning Permission Portion    
  SelectedMenu:Menu;
  IsDataIsInViewState : boolean=false;
  CanViewState : boolean=false;  
  CanApproveState : boolean=false; 
  GridShow : boolean=false; 
  DisableSave : boolean=false;
  // End of the permission portion
  // begin for Validation
  validdate : boolean= false;
  // end of validation
  //For Pop up
  TempCompoff : EmployeeCompoffModel;
  ApprovedMsg : boolean= false;
  RejectedMsg : boolean= false;
  ShowPopup : boolean= false;
  public modalRef: BsModalRef;
  public modelopt:ModalOptions;
  NoRecordMsg : boolean;

  constructor(private EmployeePortalService:EmployeePortalService, private rout: Router, private _confirmation: ConfirmationService,private userService: UserService,private modalService: BsModalService)
  { 
    this.ModelListApplication = new EmployeeCompoffModel();
    this.ModelListApplication.HalfDay=false;
    this.ModelListApplication.FullDay=false;
    this.modelopt=new ModalOptions();
    this.modelopt.class='heavy_modal';
    this.modalService.config= this.modelopt;
    this.modelopt.ignoreBackdropClick=true;
  }

  ngOnInit() 
  {
    //Begin Permission Portion
    this.SelectedMenu=this.userService.SelectedMenu;
    if(this.SelectedMenu !=undefined)
    {
      localStorage.setItem('selectedmenu',JSON.stringify(this.SelectedMenu));
      this.rout.navigate([this.SelectedMenu.RouteName]);
    }
    else
    {
      if(JSON.parse(localStorage.getItem('selectedmenu'))!=undefined)
      {
        this.SelectedMenu = JSON.parse(localStorage.getItem('selectedmenu'));
        this.rout.navigate([this.SelectedMenu.RouteName]);
      }
    }
    if(this.SelectedMenu.CanAdd)
    {
      this.IsDataIsInViewState=false;
    }
    else
    {
      this.IsDataIsInViewState=true;
    }
    if(this.SelectedMenu.CanView)
    {
      this.CanViewState=false;
    }
    else
    {
      this.CanViewState=true;
    }
    if(this.SelectedMenu.CanApprove)
    {
      this.CanApproveState=false;
    }
    else
    {
      this.CanApproveState=true;
    }
    //End of the peremission portion
    this.DisableSave=true;
    this.GetAllApplication();
    this.ApprovedMsg=false;
    this.RejectedMsg=false;
    this.ShowPopup=false;
    this.NoRecordMsg = false;
  }

  settings: ConfirmSettings | any = 
  {
    overlay: true,
    overlayClickToClose: true,
    showCloseButton: true,
    confirmText: 'Yes',
    declineText: 'No'
  };

  GetAllApplication()
  {
    this.CompOffApplication=[];
    let t =  localStorage.getItem('userToken');
    t = 'Bearer' + t;
    this.EmployeePortalService.GetEmployeeCompoffApplieslistForRH( t).then(x => 
    {
      this.NoRecordMsg = false;
      this.Approver = x;
      Object.keys(this.Approver).forEach( key => 
      {
        this.Approver[key];
        let ApproveLeave = new EmployeeCompoffModel();
        ApproveLeave = this.Approver[key];
        this.CompOffApplication.push(ApproveLeave);
      });
      if(this.CompOffApplication.length == 0)
      {
        this.NoRecordMsg = true;
      }
    });
  }

  viewAppliedEmployeeCompoff(id,template) 
  {
    this.ModelListApplication.Remarks="";
    this.GridShow=true;
    // Begning of the permission portion
    this.IsDataIsInViewState=false;
    // End of the permision portion
    let t =  localStorage.getItem('userToken');
    t = 'Bearer' + t;
    this.EmployeePortalService.GetEmployeeCompoffApplyByRefId( t,id).then(x => 
    {
      if(this.ShowPopup==true)
      {
        this.modalRef.hide();
      }
      this.modalRef = this.modalService.show(template,this.modelopt);
      this.ShowPopup=true;
      this.ApprovedMsg=false;
      this.RejectedMsg=false;
      this.Approver = x;
      Object.keys(this.Approver).forEach( key => 
      {
        // tslint:disable-next-line:no-unused-expression
        this.Approver[key];
        let Approvetemp = new EmployeeCompoffModel();
        Approvetemp = this.Approver[key];
        this.ModelListApplication.RefId=Approvetemp.RefId;
        this.ModelListApplication.EmployeeId=Approvetemp.EmployeeId;
        this.ModelListApplication.EmployeeCode=Approvetemp.EmployeeCode;
        this.ModelListApplication.EmployeeName=Approvetemp.EmployeeName; 
        this.ModelListApplication.EmployeeEmailId=Approvetemp.EmployeeEmailId; 
        this.ModelListApplication.RHEmailId=Approvetemp.RHEmailId; 
        this.ModelListApplication.RHName=Approvetemp.RHName; 
        this.ModelListApplication.RHCode=Approvetemp.RHCode; 
        this.ModelListApplication.AttendanceDate=Approvetemp.AttendanceDate; 
        this.ModelListApplication.Status=Approvetemp.Status;
        this.ModelListApplication.HalfDay=Approvetemp.HalfDay;
        this.ModelListApplication.FullDay=Approvetemp.FullDay;
        if(Approvetemp.HalfDay==true)
        {
          this.ModelListApplication.Fromvalue="HalfDay";
        }
        if(Approvetemp.FullDay==true)
        {
          this.ModelListApplication.Fromvalue="FullDay";
        }
        this.ModelListApplication.ActualInTime=Approvetemp.ActualInTime;
        this.ModelListApplication.ActualOutTime=Approvetemp.ActualOutTime;
        this.ModelListApplication.ActualWorkingDuration=Approvetemp.ActualWorkingDuration; 
        this.ModelListApplication.Reason=Approvetemp.Reason;
        this.ModelListApplication.CompanyId=Approvetemp.CompanyId;  
        this.ModelListApplication.SentMailid=Approvetemp.SentMailid;
        this.ModelListApplication.SentMailPassword=Approvetemp.SentMailPassword;
        this.ModelListApplication.HRISURL=Approvetemp.HRISURL;
      });
      // End for check company code duplication
    });
  }
  
  EmployeeCompoffApproved(template) :void
  {
    this.DisableSave=false;
    let t =  localStorage.getItem('userToken');
    t = 'Bearer' + t;
    if(this.ModelListApplication.RefId > 0)
    {
      this.ModelListApplication.IsApproved=true;
      this.ModelListApplication.IsRejected=false;
      this.EmployeePortalService.EmployeeCompoffApprovedOrRejected(t ,this.ModelListApplication).subscribe(res=>
      {
        this.RefId=res;
        this.ModelListApplication.RefId=0;  
        if(this.RefId>0)
        {
          this.ModelListApplication.Remarks="";
          this.ModelListApplication.RemarksAll="";
          this.modalRef.hide();
          this.ApprovedMsg=true;
          this.RejectedMsg=false;
          this.ShowPopup=false;
          this.modalRef = this.modalService.show(template);
          this.CompOffApplication=[];
          this.GetAllApplication();
          this.DisableSave=true;
        }
      });                  
    }
  }

  EmployeeCompoffRejected(template) :void
  {
    this.DisableSave=false;
    let t =  localStorage.getItem('userToken');
    t = 'Bearer' + t;
    if(this.ModelListApplication.RefId > 0)
    {
      this.ModelListApplication.IsApproved=false;
      this.ModelListApplication.IsRejected=true;
      this.EmployeePortalService.EmployeeCompoffApprovedOrRejected(t ,this.ModelListApplication).subscribe(res=>
      {
        this.RefId=res;
        this.ModelListApplication.RefId=0;  
        if(this.RefId>0)
        {
          this.ModelListApplication.Remarks="";
          this.ModelListApplication.RemarksAll="";
          this.modalRef.hide();
          this.ApprovedMsg=false;
          this.RejectedMsg=true;
          this.ShowPopup=false;
          this.modalRef = this.modalService.show(template);
          this.CompOffApplication=[];
          this.GetAllApplication();
          this.DisableSave=true;
        }
      });                  
    }
  }

  RefreshPage()
  {
    this.rout.navigateByUrl('/ApproveOrReject/RegularizationApproval', {skipLocationChange: true}).then(()=>this.rout.navigate(["/ApproveOrReject/CompOffApproval"]));
  }

  SelectedChange(rowid,ev)
  {
    this.TempCompoff =this.CompOffApplication[rowid];
    if(ev.target.checked==true)
    {
      this.TempCompoff.Selected=true;
    }
    else
    {
      this.TempCompoff.Selected=false;
    }
  }

  checkAll(ev) 
  {
    if(ev.target.checked == true)
    {
      var J=this.CompOffApplication.length;
      for(var i=0;i<J;i++) 
      {
        this.CompOffApplication[i].Selected=true;
      }
    }
    else
    {
      var J=this.CompOffApplication.length;
      for(var i=0; i<J; i++)
      {
        this.CompOffApplication[i].Selected=false;
      }
    }
  }

  CompOffApplicationApprovedAll(template) :void
  {
    if(this.CompOffApplication.length > 0)
    {
      this._confirmation.create('Confirm to Approve', 'Press Yes to Approve', this.settings)
      .subscribe((ans: ResolveEmit) => 
      {
        if (ans.resolved == true) 
        {
          this.DisableSave=false;
          let t =  localStorage.getItem('userToken');
          t = 'Bearer' + t;
          var j=0;
          var l=this.CompOffApplication.length;
          this.CompOffApplication.forEach(item => 
          {
            j=j+1;
            if(item.RefId > 0 && item.Selected == true)
            {
              item.Remarks=this.ModelListApplication.RemarksAll;
              item.IsApproved=true;
              item.IsRejected=false;
              this.EmployeePortalService.EmployeeCompoffApprovedOrRejected(t ,item).subscribe(res=>
              {
                this.RefId=res;
                item.RefId=0;  
                if(j == this.CompOffApplication.length)
                {
                  if(this.ShowPopup==true)
                  {
                    this.modalRef.hide();
                  }
                  this.ModelListApplication.RemarksAll="";
                  this.ApprovedMsg=true;
                  this.RejectedMsg=false;
                  this.ShowPopup=false;
                  this.modalRef = this.modalService.show(template);
                  this.CompOffApplication=[];
                  this.GetAllApplication();
                  this.DisableSave=true;
                }
              });                  
            }
          })
        }
      })
    }
  }

  CompOffApplicationRejectedAll(template) :void
  {
    if(this.CompOffApplication.length > 0)
    {
      this._confirmation.create('Confirm to Reject', 'Press Yes to Reject', this.settings)
      .subscribe((ans: ResolveEmit) => 
      {
        if (ans.resolved == true) 
        {
          this.DisableSave=false;
          let t =  localStorage.getItem('userToken');
          t = 'Bearer' + t;
          var j=0;
          var l=this.CompOffApplication.length;
          this.CompOffApplication.forEach(item => 
          {
            j=j+1;
            if(item.RefId > 0 && item.Selected == true)
            {
              item.Remarks=this.ModelListApplication.RemarksAll;
              item.IsApproved=false;
              item.IsRejected=true;
              this.EmployeePortalService.EmployeeCompoffApprovedOrRejected(t ,item).subscribe(res=>
              {
                this.RefId=res;
                item.RefId=0;  
                if(j == this.CompOffApplication.length)
                {
                  if(this.ShowPopup==true)
                  {
                    this.modalRef.hide();
                  }
                  this.ModelListApplication.RemarksAll="";
                  this.ApprovedMsg=false;
                  this.RejectedMsg=true;
                  this.ShowPopup=false;
                  this.modalRef = this.modalService.show(template);
                  this.CompOffApplication=[];
                  this.GetAllApplication();
                  this.DisableSave=true;
                }
              });                  
            }
          })
        }
      })
    }
  }
}